











import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ParagraphSize } from '../base-paragraph';
import { AvatarSize } from '../base-avatar';
import { SkeletonType } from './enums/skeleton-type';

@Component({
  name: 'BaseSkeleton',
  data: () => ({
    SkeletonType,
  }),
})
export default class BaseSkeleton extends Vue {
  @Prop({ default: SkeletonType.Unknown }) type: SkeletonType;
  @Prop({ default: 4 }) rows: number;
  @Prop() size: ParagraphSize;
  @Prop({ default: AvatarSize.Medium }) avatarSize: AvatarSize;
  @Prop({ default: false }) fullWidth: boolean;
  @Prop({ default: true }) label: boolean;

  get calculatedHeight(): string {
    const textareaPadding = 1.5;
    const textareaLineHeight = 1.125;
    return this.type === SkeletonType.Textarea
      ? `${this.rows * textareaLineHeight + textareaPadding}rem`
      : null;
  }
}
